import { Component, OnInit, Output, EventEmitter, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { GlobalObservables } from '../../../../../app.global.observer';
import { HelperService } from '../../../services/helper.service';
import { Global } from '../../../../../app.global';
import { KeyDescriptionViewModel } from '../../../viewmodels/keyDescriptionViewModel';

import { RadioQuestionModel } from '../../../viewmodels/policy-item.model';
import { StaffCopy } from '../../../helper/textcopy/policies.text';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'staff-policy',
  templateUrl: './staff.component.html',
})
export class StaffComponent implements OnInit, OnDestroy {
  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onSavePolicies = new EventEmitter();
  policiesAnswersSetted = new Subscription();
  policiesAnswers: any = this.global.policiesAnswers;

  textCopy = StaffCopy;

  authorsName = new RadioQuestionModel();
  authorsNameFormat = new RadioQuestionModel();
  singleLine = new RadioQuestionModel();
  appearName = '';
  signature = '';
  userExpert = {
    name: '',
    phone: '',
    mobile: '',
    email: '',
  };
  technicalExpert = {
    name: '',
    phone: '',
    mobile: '',
    email: '',
  };
  userDailyTarget = '';

  constructor(
    public global: Global,
    private globalObs: GlobalObservables,
    private helpServ: HelperService
  ) {}

  ngOnInit() {
    this.setAuthorsNameQuestion();
    this.setAuthorsNameFormatQuestion();
    this.setSingleLineQuestion();

    if (this.helpServ.isEmpty(this.policiesAnswers)) {
      this.onPoliciesAnswersSetted();
    } else {
      this.setSelectedValues();
    }
  }

  setAuthorsNameQuestion() {
    this.authorsName.data = {
      title: this.textCopy.authorsNameTitle,
      includeTitle: true,
      answers: [
        {
          text: 'yes',
          value: 'y',
        },
        {
          text: 'no',
          value: 'n',
        },
      ],
    };
  }
  onAuthorsNameSelected(answerValue) {
    this.authorsName.valueSelected = answerValue;
  }

  setAuthorsNameFormatQuestion() {
    this.authorsNameFormat.data = {
      title: this.textCopy.authorsNameFormatTitle,
      answers: [
        { text: 'Jack Borneo, Parking Supervisor', value: '0' },
        { text: 'J Borneo, Parking Supervisor', value: '1' },
        { text: 'Mr J Borneo, Parking Supervisor', value: '2' },
        { text: 'Mr J Borneo, Parking Supervisor', value: '3' },
      ],
    };
  }
  onAuthorsNameFormatSelected(answerValue) {
    this.authorsNameFormat.valueSelected = answerValue;
  }

  setSingleLineQuestion() {
    this.singleLine.data = {
      title: this.textCopy.singleLineTitle,
      answers: [
        { text: 'Keep the wording on one line', value: '0' },
        { text: 'Split the wording over two lines', value: '1' },
      ],
    };
  }
  onSingleLineSelected(answerValue) {
    this.singleLine.valueSelected = answerValue;
  }

  setExpertsDetails() {
    this.userExpert = {
      name: this.policiesAnswers['20_3_1'],
      phone: this.policiesAnswers['20_3_2'],
      mobile: this.policiesAnswers['20_3_3'],
      email: this.policiesAnswers['20_3_4'],
    };
    this.technicalExpert = {
      name: this.policiesAnswers['20_3_5'],
      phone: this.policiesAnswers['20_3_6'],
      mobile: this.policiesAnswers['20_3_7'],
      email: this.policiesAnswers['20_3_8'],
    };
  }

  setSelectedValues() {
    console.log(this.policiesAnswers);
    this.authorsName.valueSelected = this.policiesAnswers['20_2'];
    this.authorsNameFormat.valueSelected = this.policiesAnswers['20_2_1'];
    this.appearName = this.policiesAnswers['20_2_2'];
    this.signature = this.policiesAnswers['20_2_3'];
    this.singleLine.valueSelected = this.policiesAnswers['20_2_4'];
    this.userDailyTarget = this.policiesAnswers['20_4'];

    this.setExpertsDetails();
  }

  onPoliciesAnswersSetted() {
    this.policiesAnswers = this.global.policiesAnswers;
    this.policiesAnswersSetted = this.globalObs.onPoliciesAnswersSetted.subscribe(() => {
      this.setSelectedValues();
    });
  }

  submitPolicyCategory() {
    let policyList = new Array<KeyDescriptionViewModel>();
    policyList = [
      { id: '20_2', description: this.authorsName.valueSelected },
      { id: '20_2_1', description: this.authorsNameFormat.valueSelected },
      { id: '20_2_2', description: this.appearName },
      { id: '20_2_3', description: this.signature },
      { id: '20_2_4', description: this.singleLine.valueSelected },
      { id: '20_3_1', description: this.userExpert.name },
      { id: '20_3_2', description: this.userExpert.phone },
      { id: '20_3_3', description: this.userExpert.mobile },
      { id: '20_3_4', description: this.userExpert.email },
      { id: '20_3_5', description: this.technicalExpert.name },
      { id: '20_3_6', description: this.technicalExpert.phone },
      { id: '20_3_7', description: this.technicalExpert.mobile },
      { id: '20_3_8', description: this.technicalExpert.email },
      { id: '20_4', description: this.userDailyTarget },
    ];

    this.onSavePolicies.emit(policyList);
  }

  ngOnDestroy() {
    if (this.helpServ.isEmpty(this.policiesAnswers)) {
      this.policiesAnswersSetted.unsubscribe();
    }
  }
}
